import React, { useState } from 'react';
import { Package, Ruler, Settings } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthProvider';
import { usePermissions } from '../../auth/permissions';
import InventorySettingsModal from '../../components/InventorySettingsModal';
import Toast from '../../components/Toast';
import './settings.css';

export default function SettingsPage() {
  const { user } = useAuth();
  const { canRead } = usePermissions();
  const [inventoryOpen, setInventoryOpen] = useState(false);
  const [toast, setToast] = useState(null);
  return <section className="wh-page settings-page">
    <div className="wh-title"><h1>Settings</h1></div>
    <div className="settings-options">
      {canRead('Inventory') && <button type="button" className="wh-panel settings-option" onClick={() => setInventoryOpen(true)}>
        <Settings size={22} /><span><strong>Inventory Settings</strong><small>Choose how new inventory calculates volume and weights.</small></span>
      </button>}
      {canRead('PackagingTypes') && <Link className="wh-panel settings-option" to="/packaging-types">
        <Package size={22} /><span><strong>Packaging Types</strong><small>Manage packaging types used for inventory.</small></span>
      </Link>}
      {canRead('Units') && <Link className="wh-panel settings-option" to="/units">
        <Ruler size={22} /><span><strong>Units</strong><small>Manage units used for inventory.</small></span>
      </Link>}
      {!canRead('Inventory') && !canRead('PackagingTypes') && !canRead('Units') && <p>No settings available for your permissions.</p>}
    </div>
    {canRead('Inventory') && inventoryOpen && <InventorySettingsModal user={user} onClose={() => setInventoryOpen(false)} onSaved={() => {
      setInventoryOpen(false);
      setToast({ message: 'Inventory settings updated successfully.', tone: 'success' });
    }} />}
    <Toast toast={toast} onClose={() => setToast(null)} />
  </section>;
}
